export default "__VITE_ASSET__CEeILBxe__"